import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  HttpClient
} from '@angular/common/http';

import { LanguageService } from '../../services/language.service';


@Component({
  selector: 'app-popular-brands',

  standalone: true,

  imports: [
    CommonModule
  ],

  templateUrl:
    './popular-brands.html',

  styleUrls: [
    './popular-brands.css'
  ]
})
export class PopularBrands
  implements OnInit {

  brands: any[] = [];

  // অ্যাডমিন → হোমপেজ ডিজাইন থেকে দেওয়া টাইটেল (না দিলে ডিফল্ট অনুবাদ)
  @Input() title = '';

  loading = true;

  // প্রথমে ২ সারি (১২টা) দেখায়; "সব দেখুন" চাপলে সবগুলো
  readonly previewCount = 12;

  expanded = false;

  // যাদের লোগো লোড হয়নি — সেখানে ব্র্যান্ডের নাম দেখাবে
  private failed = new Set<any>();


  readonly api =
    'https://superbangladesh-api-1.onrender.com/api/popular-brands/active';


  constructor(
    private http: HttpClient,
    public languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  t(key: string): string {
    return this.languageService.translate(key);
  }

  get bn(): boolean {
    return this.languageService.language() === 'bn';
  }

  get visible(): any[] {

    return this.expanded
      ? this.brands
      : this.brands.slice(0, this.previewCount);
  }

  get canToggle(): boolean {
    return this.brands.length > this.previewCount;
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }


  ngOnInit(): void {

    this.loadBrands();
  }


  loadBrands(): void {

    this.loading = true;

    this.http
      .get<any[]>(this.api)
      .subscribe({

        next: (res: any[]) => {

          this.brands =
            Array.isArray(res)
              ? res
              : [];

          this.loading = false;

          this.cdr.markForCheck();
        },

        error: (err: any) => {

          console.error(
            'Popular Brands load failed',
            err
          );

          this.brands = [];

          this.loading = false;

          this.cdr.markForCheck();
        }

      });
  }


  showImage(brand: any): boolean {

    return !!brand?.imageUrl
      && !this.failed.has(brand?.id ?? brand?.name);
  }

  onImageError(brand: any): void {

    this.failed.add(brand?.id ?? brand?.name);

    this.cdr.markForCheck();
  }


  trackByBrand(
    index: number,
    brand: any
  ): any {

    return (
      brand?.id ??
      index
    );
  }
}
